import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class ShiftRosterService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  ESS_RosterFillComboLoad(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_RosterFillCombo/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpRoster_SelectGet(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpRoster_Select/Get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpRoster_InsertUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpRoster_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpRoster_ExcelUpload(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpRoster_Excel/Upload`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
